import { UpdateCommonAreaModel } from '../models/commonAreaEntityModels';
import { PayloadUpdateCommonAreaModel } from '../models/payloadCommonAreaModels';
import { commonAreaTimeAvailabilityToPayload } from './commonAreaTimeAvailabilityToPayload';

export const commonAreaToPayload = ({
  id,
  name,
  capacity,
  bookingDuration,
  backgroundImage,
  sensors,
  daysAvailability,
  timeAvailability,
  infoUserTitle,
  infoUserDescription,
  hasBooking,
  enabled,
  maximumBookingsByUser,
  maximumTimeAvailability,
}: UpdateCommonAreaModel): PayloadUpdateCommonAreaModel => {
  const parsedAvailability = daysAvailability.join();
  const transformTimeAvailability = timeAvailability.map((time) => commonAreaTimeAvailabilityToPayload(time));

  return {
    id,
    name,
    capacity: capacity,
    booking_duration: bookingDuration,
    background_image: backgroundImage || null,
    sensor_ids: sensors,
    days_availability: parsedAvailability,
    time_availability: transformTimeAvailability,
    info_user_title: infoUserTitle || null,
    info_user_description: infoUserDescription || null,
    has_booking: hasBooking,
    enabled,
    maximum_bookings_by_user: maximumBookingsByUser,
    maximum_time_availability: {
      time_period: maximumTimeAvailability.timePeriod,
      value: maximumTimeAvailability.value,
    },
  };
};
